'use client'

import ImageWithFallback from '@/components/common/image-with-fallback'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Textarea } from '@/components/ui/textarea'
import getUserName from '@/helpers/get-user-name'
import { getUserProfilePictureUrl } from '@/helpers/user'
import { useState } from 'react'

export default function ManageDriverReasonDialog({
  open,
  setOpen,
  handleSubmit,
  member,
  setMember,
  reasonType,
}) {
  const [reason, setReason] = useState('')
  const isBulkKicked = reasonType === 'bulk-kick'

  function closeModal() {
    setOpen(false)
    setMember(null)
  }

  function handleSubmitClick() {
    handleSubmit(reason)
    closeModal()
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="w-full p-5 sm:w-[400px] desktop-sm:w-[600px]"
        showCloseButton={false}
      >
        <DialogHeader>
          <div className="flex flex-col items-center justify-center gap-2 lg:flex-row lg:justify-between">
            <DialogTitle className="capitalize">
              {isBulkKicked ? 'Remove All Drivers' : `${reasonType} Member`}
            </DialogTitle>

            {member && !isBulkKicked && (
              <div className="flex items-center justify-center gap-2">
                <div className="relative h-[35px] w-[35px] rounded-full">
                  <div className="flex h-[35px] w-[35px] items-center justify-center rounded-full bg-black">
                    <ImageWithFallback
                      className="overflow-hidden rounded-full"
                      src={getUserProfilePictureUrl(member.user, {
                        profile: 'driver',
                      })}
                      alt="User Image"
                      fill
                    />
                  </div>
                </div>
                <DialogDescription>
                  <span className="text-p-2 font-semibold text-shades-0">
                    {getUserName(member.user, { profile: 'driver' })}
                  </span>
                </DialogDescription>
              </div>
            )}

            {member && isBulkKicked && (
              <DialogDescription>
                <span className="text-p-2 font-semibold text-shades-0">
                  {member.user.username}
                </span>
              </DialogDescription>
            )}
          </div>

          <div className="divider"></div>
        </DialogHeader>

        <div className="max-h-[400px] overflow-y-auto">
          <label htmlFor="reasonInput" className="mb-1 text-sm font-medium">
            Reason for{' '}
            <span className="capitalize">
              {isBulkKicked ? 'removal' : reasonType}
            </span>
          </label>

          <Textarea
            id="reasonInput"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            placeholder={
              isBulkKicked
                ? 'e.g., Resetting event attendance for fresh registrations'
                : ''
            }
            className="focus:ring-0! focus:ring-offset-0!"
          />
        </div>

        <DialogFooter className="flex items-center gap-3">
          <Button onClick={closeModal} variant="underline">
            Cancel
          </Button>
          <Button
            onClick={handleSubmitClick}
            variant="destructive"
            className="px-4 py-2"
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
